import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Soup, BookOpen, Mail, Eye, Wand2 } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  const load = async () => {
    try {
      const r = await api.get("/admin/stats");
      setStats(r.data);
    } catch (e) {
      toast.error("Erreur de chargement des statistiques");
    }
  };

  useEffect(() => { load(); }, []);

  if (!stats) return <div className="text-[hsl(var(--text-muted))]">Chargement…</div>;

  const cards = [
    { icon: Soup, label: "Recettes publiées", value: stats.total_recipes, sub: `${stats.auto_generated_recipes} via IA` },
    { icon: BookOpen, label: "Guides", value: stats.total_guides },
    { icon: Eye, label: "Vues totales", value: stats.total_recipe_views },
    { icon: Mail, label: "Newsletter", value: stats.newsletter_subscribers, sub: "abonnés" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <p className="overline mb-2">Vue d'ensemble</p>
      <h1 className="font-serif text-4xl mb-2">Tableau de bord</h1>
      <p className="text-[hsl(var(--text-secondary))] mb-10">Bienvenue dans votre back-office Recette-Diabete.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        {cards.map((c) => (
          <div key={c.label} className="bg-white border border-[hsl(var(--border-light))] p-5 rounded-sm" data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>
            <c.icon className="w-5 h-5 text-[hsl(var(--brand-primary))] mb-3" strokeWidth={1.5} />
            <p className="overline text-xs mb-1">{c.label}</p>
            <p className="font-serif text-4xl">{c.value}</p>
            {c.sub && <p className="text-xs text-[hsl(var(--text-muted))] mt-1">{c.sub}</p>}
          </div>
        ))}
      </div>

      <div className="bg-white border border-[hsl(var(--border-light))] p-8 rounded-sm" data-testid="ai-batch-panel">
        <div className="flex items-start gap-4">
          <Wand2 className="w-6 h-6 text-[hsl(var(--brand-primary))] flex-shrink-0 mt-1" strokeWidth={1.5} />
          <div className="flex-1">
            <p className="overline mb-2">Adaptation IA · Claude Sonnet 4.6</p>
            <h2 className="font-serif text-2xl mb-2">Adapter un batch de recettes</h2>
            <p className="text-[hsl(var(--text-secondary))] mb-6 max-w-2xl">
              Fournissez vos recettes traditionnelles (texte brut séparé par <code>---</code> ou fichier .txt/.md/.csv).
              Claude les adapte une à une en IG bas, en conservant l'identité du plat. Image Nano Banana en option.
            </p>
            <Link to="/admin/batch" data-testid="open-batch-btn" className="btn-primary">
              <Sparkles className="w-4 h-4" strokeWidth={1.5} />
              Ouvrir l'adaptateur batch
            </Link>
          </div>
        </div>
      </div>

      {stats.categories?.length > 0 && (
        <div className="mt-8 bg-white border border-[hsl(var(--border-light))] p-6 rounded-sm">
          <p className="overline mb-3">Par catégorie</p>
          <div className="flex flex-wrap gap-2">
            {stats.categories.map((c) => (
              <span key={c._id} className="text-sm px-3 py-1.5 bg-[hsl(var(--bg-subtle))] rounded-sm">
                {c._id}: <strong>{c.count}</strong>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
